import { isMiniApp } from "./localStorage";

/* eslint-disable quotes */
const transformKeysForMiniApp = [
  "signup_agreement_message",
  "results__signup_agreement_message",
  "agreed_to_terms_and_conditions_generic",
  "results__service_termination_disclaimer",
  "results__agreed_to_policy_policy",
  "agreed_to_terms_and_conditions",
  "direct_paylink_faq",
  "service_termination_disclaimer",
  "agreed_to_policy_policy",
  "results__direct_paylink_faq",
  "results__agreed_to_terms_and_conditions"
];

const replaceTargetBlank = val => {
  return (
    val &&
    val.includes("target=") &&
    val.replaceAll(`target="_blank"`, "").replaceAll(`target='_blank'`, "")
  );
};

export const languageAPIFormatCorrector = data => {
  if (!data) {
    return {};
  }
  const results = {};
  const miniApp = isMiniApp();
  data.forEach(function(item) {
    results[item?.key] =
      miniApp && transformKeysForMiniApp.includes(item?.key)
        ? replaceTargetBlank(item?.value)
        : item?.value;
  });
  return results;
};
